import React, {Component} from 'react';
import './Banner.css'

class Banner extends Component {
	render() {
		return (
			<div className="banner-container light">
				<div className="centered">
					<div>
						<div className="banner-box-center banner-text">Tiebreaker Consulting</div>
						<div className="banner-box-center banner-text-small"><i>konsulter som brinner för systemutveckling</i></div>
					</div>
					<div className="banner-box-center">
						<button className="primary-button"
										onClick={() => document.location.href = '#services'}>
							Läs mer
						</button>
					</div>
				</div>
			</div>
		);
	}
}
export default Banner
